import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { OKTA_CONFIG, provideOktaAuth } from '@okta/okta-angular';
import { provideNgxMask } from 'ngx-mask';
import { createOktaConfig } from './core/factories/okta-config.factory';

import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptors,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { routes } from './app.routes';
import { authInterceptor } from './core/interceptors/auth/auth.interceptor';
import { ErrorInterceptor } from './core/interceptors/error/error.interceptor';
import { AuditCorrelationService } from './core/services/audit-correlation/audit-correlation.service';
import { AuthService } from './core/services/auth/auth.service';
import { ConfigService } from './core/services/config/config.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(routes),
    provideHttpClient(withInterceptors([authInterceptor]), withInterceptorsFromDi()),
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    provideNgxMask(),
    provideAppInitializer(async () => {
      const configService = inject(ConfigService);
      const authService = inject(AuthService);
      // Instantiate the correlation service at startup so it subscribes to
      // router navigations from the initial navigation onward.
      inject(AuditCorrelationService);
      await configService.initialize();
      await authService.initialize();
    }),
    provideOktaAuth(),
    {
      provide: OKTA_CONFIG,
      useFactory: createOktaConfig,
      deps: [ConfigService],
    },
  ],
};
